<template>
  <a class="btn-edit" href="javascript:;" v-text="label" v-on="$listeners"></a>
</template>
<style scoped>
  .btn-edit {
    font-size: 14px;
    margin: 3px;
    text-decoration: none;
  }
  .btn-edit:link {
    color: #337AB7;
  }
  .btn-edit:visited, .btn-edit:hover {
    color: #66b1FF;
  }
</style>
<script>
  export default {
    props: {
      label: String
    }
  }
</script>
